import Settings from 'settings.json';

type SettingsEnvironment = keyof typeof Settings;

const mode = import.meta.env.MODE as SettingsEnvironment;
const environmentSettings = Settings[mode] ?? Settings.production;
const locale = environmentSettings.locale;

export const formatCurrency = (value: string | number) => {
  return parseFloat(String(value)).toLocaleString(locale);
};

export const formatDuration = (execTime: string | number | null | undefined, unit = 'ms') => {
  if (execTime === null || execTime === undefined || execTime === '') {
    return null;
  }
  const value = Number(execTime);
  if (!Number.isFinite(value)) {
    return null;
  }
  const rawSeconds = unit === 's' ? value : value / 1000;
  const totalSeconds = rawSeconds > 0 ? Math.max(1, Math.round(rawSeconds)) : 0;
  if (totalSeconds < 60) {
    return `${totalSeconds}s`;
  }
  const minutes = (totalSeconds / 60).toFixed(1).replace(/\.0$/, '');
  return `${minutes}m`;
};
